import { sessionConstants } from "../constants";
import { sessionService } from "../../services";
import { history } from "../../helpers";
import Swal from "sweetalert2";
import { constants } from "../../Constants";

export const sessionActions = {
  UpdateSessionStatus,
  OpenTokService,
  CreateNote,
  getSessions,
  getSessionStatus,
  getNatureIssues,
  UpdateSessionHistoryStatus,
  UpdateIssueNature,
  csvSessions
};
function UpdateSessionStatus(status) {
  return dispatch => {
    dispatch(request());
    sessionService.UpdateSessionStatus(status).then(
      users => dispatch(success(users)),
      error => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: sessionConstants.UPDATESESSION_REQUEST };
  }
  function success(data) {
    return { type: sessionConstants.UPDATESESSION_SUCCESS, data };
  }
  function failure(error) {
    return { type: sessionConstants.UPDATESESSION_FAILURE, error };
  }
}

function OpenTokService(appointment_id, os, browser, device) {
  return dispatch => {
    dispatch(request());
    sessionService.OpenTokService(appointment_id, os, browser, device).then(
      videoData => {
        dispatch(success(videoData));
        let role = JSON.parse(localStorage.getItem("user")).role;
        if (role === 1) {
          history.push(`/session/${videoData.session}/${videoData.patient_token}/${appointment_id}`);
        } else if (role === 0) {
          history.push(`/session/${videoData.session}/${videoData.counsellor_token}/${appointment_id}`);
        }
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: sessionConstants.GETSESSION_REQUEST };
  }
  function success(videoData) {
    return { type: sessionConstants.GETSESSION_SUCCESS, videoData };
  }
  function failure(error) {
    return { type: sessionConstants.GETSESSION_FAILURE, error };
  }
}

function CreateNote(note, user_id, appointment_id) {
  return dispatch => {
    const promise = new Promise((resolve, reject) => {
      sessionService.CreateNote(note, user_id, appointment_id).then(
        notedata => {
          resolve(notedata);
        },
        error => {
          reject(error);
        }
      );
    });
    return promise;
  };

  /*   function request() { return { type: sessionConstants.GETSESSION_REQUEST } }
    function success(videoData) {
        return { type: sessionConstants.GETSESSION_SUCCESS, videoData }
    }
    function failure(error) { return { type: sessionConstants.GETSESSION_FAILURE, error } } */

  /*   function request() { return { type: sessionConstants.GETSESSION_REQUEST } }
      function success(videoData) {
          return { type: sessionConstants.GETSESSION_SUCCESS, videoData }
      }
      function failure(error) { return { type: sessionConstants.GETSESSION_FAILURE, error } } */
}


function getSessions(pageNum, itemsCount, startDate, endDate) {
  return (dispatch) => {
    const promise = new Promise((resolve) => {
      dispatch(request(true));
      sessionService.getSessions(pageNum, itemsCount, startDate, endDate).then((res) => {
        resolve(res);
        dispatch(success(res));
      });
    });
    return promise;
  };
  function request(res) {
    return { type: sessionConstants.GETSESSION_HISTORY_REQUEST, res };
  }
  function success(res) {
    res.currentPage = pageNum
    return {
      type: sessionConstants.GETSESSION_HISTORY_SUCCESS,
      res,
    };
  }
}

function csvSessions(startDate, endDate) {
  return (dispatch) => {
    const promise = new Promise((resolve) => {
      dispatch(request(true));
      sessionService.csvSessions(startDate, endDate).then((res) => {
        resolve(res);
        dispatch(success(res));
      });
    });
    return promise;
  };
  function request(res) {
    return { type: sessionConstants.GETSESSION_CSV_HISTORY_REQUEST, res };
  }
  function success(res) {
    return {
      type: sessionConstants.GETSESSION_CSV_HISTORY_SUCCESS,
      res,
    };
  }
}

function getNatureIssues() {
    return (dispatch) => {
      const promise = new Promise((resolve) => {
        dispatch(request(true));
        sessionService.getNatureIssues().then((res) => {
          resolve(res);
          dispatch(success(res));
        });
      });
      return promise;
    };
    function request(res) {
      return { type: sessionConstants.SESSION_NATURE_OF_ISSUE_REQUEST, res };
    }
    function success(res) {
      return {
        type: sessionConstants.SESSION_NATURE_OF_ISSUE_SUCCESS,
        res,
      };
    }
  }

function getSessionStatus() {
	return (dispatch) => {
		const promise = new Promise((resolve) => {
      dispatch(request(true));
      sessionService.getSessionStatus().then((res) => {
        resolve(res);
        dispatch(success(res));
      });
    });
    return promise;
  };
  function request(res) {
    return { type: sessionConstants.SESSION_STATUS_REQUEST, res };
  }
  function success(res) {
    return {
      type: sessionConstants.SESSION_STATUS_SUCCESS,
      res,
    };
  }
}

function UpdateSessionHistoryStatus(status) {
  return dispatch => {
    dispatch(request(true));
    sessionService.UpdateSessionHistoryStatus(status).then(
      users => dispatch(success(users)),
      error => dispatch(failure(error.toString()))
    );
  };
  function request() {
    return { type: sessionConstants.SESSION_HISTORY_STATUS_REQUEST };
  }
  function success(data) {
    Swal.fire(constants.MODAL_SUCCESS_AFTER_TEXT_SWAL, constants.SWAL_STATUS_UPDATE_SUCCESS_MESSAGE, constants.SWAL_SUCCESS_TEXT);
    return { type: sessionConstants.SESSION_HISTORY_STATUS_SUCCESS, data };
  }
  function failure(error) {
    Swal.fire(constants.MODAL_SUCCESS_AFTER_TEXT_SWAL, constants.SWAL_STATUS_UPDATE_FAILURE_MESSAGE, constants.SWAL_ERROR_TEXT);
    return { type: sessionConstants.SESSION_HISTORY_STATUS_FAILURE, error };
  }
}

function UpdateIssueNature (nature){
  return dispatch => {
    dispatch(request(true));
    sessionService.UpdateIssueNature(nature).then(
      users => dispatch(success(users)),
      error => dispatch(failure(error.toString()))
      );
    };
    function request() {
      return { type: sessionConstants.SESSION_UPDATE_NATURE_OF_ISSUE_REQUEST };
    }
  function success(data) {
    Swal.fire(constants.MODAL_SUCCESS_AFTER_TEXT_SWAL, constants.SWAL_NATURE_UPDATE_SUCCESS_MESSAGE, constants.SWAL_SUCCESS_TEXT);
    return { type: sessionConstants.SESSION_UPDATE_NATURE_OF_ISSUE_SUCCESS, data };
  }
  function failure(error) {
    Swal.fire(constants.MODAL_SUCCESS_AFTER_TEXT_SWAL, constants.SWAL_NATURE_UPDATE_FAILURE_MESSAGE, constants.SWAL_ERROR_TEXT);
    return { type: sessionConstants.SESSION_UPDATE_NATURE_OF_ISSUE_FAILURE, error };
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/session.actions.js